export default "__VITE_ASSET__BcIybPVT__"